import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import Clothes from "../../models/clothes/clothes.model";
import { User } from "../../models/auth/auth.model";

interface PostStateType {
    isLoading: boolean

    userPosts: Clothes[]
    postsData: Clothes[]
    postDataLastRequest: string | null
    postsByCategoryData: Clothes[]
    searchPostsData: Clothes[]
    filterPostsData: Clothes[]
    sellersPosts: Clothes[]
    myPostsData: Clothes[]
    seller: User | null

    addPostSuccess: boolean
    updatePostSuccess: boolean
    deletePostSuccess: boolean

    error: string
}

const initialState: PostStateType = {
    isLoading: false,

    userPosts: [],
    postsData: [],
    postDataLastRequest: null,
    postsByCategoryData: [],
    searchPostsData: [],
    filterPostsData: [],
    sellersPosts: [],
    myPostsData: [],
    seller: null,

    addPostSuccess: false,
    updatePostSuccess: false,
    deletePostSuccess: false,

    error: "",
};

export const PostSlice = createSlice({
    name: "Post",
    initialState: initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
        },
        getUserPostsSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.userPosts = action.payload;
        },
        getPostsSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.postsData = action.payload;
            state.postDataLastRequest = moment().format("DD-MM-YYYY HH:mm:ss");
        },
        getPostsByCategorySuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.postsByCategoryData = action.payload;
        },
        getSearchedPostsSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.searchPostsData = action.payload;
        },
        getPostsByFilterSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.filterPostsData = action.payload;
        },
        getMyPostsSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.isLoading = false;
            state.myPostsData = action.payload;
        },
        getSellerSuccess: (state, action: PayloadAction<User>) => {
            state.isLoading = false;
            state.seller = action.payload;
        },
        getSellersPostsSuccess: (state, action: PayloadAction<Clothes[]>) => {
            state.sellersPosts = action.payload;
        },
        addPostSuccess: (state) => {
            state.isLoading = false;
            state.addPostSuccess = true;
        },
        updatePostSuccess: (state) => {
            state.isLoading = false;
            state.updatePostSuccess = true;
        },
        deletePostSuccess: (state) => {
            state.isLoading = false;
            state.deletePostSuccess = true;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        clearSellerData: (state) => {
            state.seller = null;
        },
        clearState: (state) => {
            state.isLoading = false;
            state.error = "";
            state.userPosts = [];
            state.postsByCategoryData = [];
            state.searchPostsData = [];
            state.filterPostsData = [];
            state.addPostSuccess = false;
            state.updatePostSuccess = false;
            state.deletePostSuccess = false;
        }
    }
});

export default PostSlice.reducer;
export const {
    setIsLoading,
    getUserPostsSuccess,
    getPostsSuccess,
    getPostsByCategorySuccess,
    getSearchedPostsSuccess,
    getPostsByFilterSuccess,
    getMyPostsSuccess,
    getSellerSuccess,
    getSellersPostsSuccess,
    addPostSuccess,
    updatePostSuccess,
    deletePostSuccess,
    setError,
    clearSellerData,
    clearState
} = PostSlice.actions;